import React from 'react';
import { hashHistory } from 'react-router';
import { Button, Card, Progressbar, Tick } from '../../shared';
import './styles.scss';

export const Confirm = () => (
  <div className="confirm">

    <Card>
      <Progressbar>
        <div className='progress' />
        <div className='progress' />
      </Progressbar>

      <Tick />

      <div className='confirmation'>
        <h3>Setup complete!</h3>
        <p>
          Staff can clock in and out with their passcodes through the keypad, and
          these times will be sent to Tanda.
        </p>
      </div>
      <div className='next'>
        <Button className='green' onClick={() => hashHistory.push('/timeclock')}>
          <p>Start clocking in</p>
        </Button>
      </div>
    </Card>

  </div>
);


export default Confirm;



// WEBPACK FOOTER //
// ./src/components/setup/confirm/index.jsx